import { connect } from 'react-redux';
import InputModalReadyProducts from './InputModalReadyProducts';
import {
  setQuantityField,
  setZdvlLineIdField,
  setPieceIdField,
  setQcIdField,
  setQcDateField,
  setReadyPlantOperationAttribsInherit,
  updateReadyProducts,
  setInputProductsPieces,
  setQuantityOffField,
  setProductUnit,
  setZdvlLineNumIdField
} from '../../../store/actions/inputReadyProducts';
import { getReadyProducts } from '../../../store/actions/correctionReadyProducts';

const mapStateToProps = ({
  userReducer,
  tabsReducer,
  inputReadyProductReducer,
  correctionReadyProductsReducer
}) => ({
  userReducer,
  tabsReducer,
  inputReadyProductReducer,
  correctionReadyProductsReducer
});
const mapDispatchToProps = {
  setQuantityField,
  setZdvlLineIdField,
  setZdvlLineNumIdField,
  setPieceIdField,
  setQcIdField,
  setQcDateField,
  updateReadyProducts,
  getReadyProducts,
  setInputProductsPieces,
  setQuantityOffField,
  setProductUnit,
  setReadyPlantOperationAttribsInherit
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InputModalReadyProducts);
